var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "180", height: "50", viewBox: "0 0 180 50" }, props),
    React.createElement("defs", null),
    React.createElement(
      "text",
      { id: "eGym\u4E09\u56FD\u5FD7\u904B\u52D5\u5C65\u6B74", className: styles["cls-1"] || "cls-1", x: "41.402", y: "32.053" },
      "eGym\u4E09\u56FD\u5FD7 \u904B\u52D5\u5C65\u6B74"
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/molecules/header/images/logo.svg
// module id = 606
// module chunks = 0